export default "images/welcome-to-overlook.jpg";